export class HowPrint {
  table_guest = [];
  template = {};
  how_print = {};

  constructor(obj) {
    obj = obj || {};
    this.table_guest = obj.table_guest;
    this.template = obj.template || {};
  }
}
